mutation NotePendingApprovalCreate($input: NotePendingApprovalCreateInput!) {
  notePendingApprovalCreate(input: $input) { 
    clientMutationId
  }
}
